export type NonMvpRouteGateConfig = {
  dueDiligence: boolean;
  team: boolean;
  outreach: boolean;
};

const TRUTHY = new Set(['1', 'true', 'yes', 'on']);

const toBool = (value: string | undefined, fallback: boolean): boolean => {
  if (value == null) return fallback;
  return TRUTHY.has(value.trim().toLowerCase());
};

export const buildNonMvpRouteGateConfig = (options: {
  isProduction: boolean;
  dueDiligenceOverride?: string;
  teamOverride?: string;
  outreachOverride?: string;
}): NonMvpRouteGateConfig => {
  const fallback = !options.isProduction;

  return {
    dueDiligence: toBool(options.dueDiligenceOverride, fallback),
    team: toBool(options.teamOverride, fallback),
    outreach: toBool(options.outreachOverride, fallback),
  };
};

export const nonMvpRouteGateConfig = buildNonMvpRouteGateConfig({
  isProduction: import.meta.env.PROD,
  dueDiligenceOverride: import.meta.env.VITE_ENABLE_ROUTE_DUE_DILIGENCE,
  teamOverride: import.meta.env.VITE_ENABLE_ROUTE_TEAM,
  outreachOverride: import.meta.env.VITE_ENABLE_ROUTE_OUTREACH,
});

const normalizePath = (path: string): string => {
  if (!path) return '/';
  const withoutQuery = path.split('?')[0].split('#')[0];
  if (withoutQuery.length > 1 && withoutQuery.endsWith('/')) {
    return withoutQuery.slice(0, -1);
  }
  return withoutQuery;
};

export const gatedRouteAliases: Record<keyof NonMvpRouteGateConfig, string[]> = {
  dueDiligence: ['/due-diligence'],
  team: ['/team'],
  outreach: ['/outreach', '/offering-memorandums'],
};

export const isNonMvpRouteEnabled = (
  path: string,
  gateConfig: NonMvpRouteGateConfig = nonMvpRouteGateConfig,
): boolean => {
  const normalized = normalizePath(path);

  if (gatedRouteAliases.dueDiligence.includes(normalized)) return gateConfig.dueDiligence;
  if (gatedRouteAliases.team.includes(normalized)) return gateConfig.team;
  if (gatedRouteAliases.outreach.includes(normalized)) return gateConfig.outreach;

  return true;
};

export const getDisabledRouteFallback = (
  path: string,
  gateConfig: NonMvpRouteGateConfig = nonMvpRouteGateConfig,
): string | null => {
  return isNonMvpRouteEnabled(path, gateConfig) ? null : '/dashboard';
};
